import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from "react-confetti";
import { motion } from "framer-motion";
import './Final.css';

// Importando o contexto e os assets
import { useGlobal } from '../../context/GlobalContext';
import FinishIcon from '../../assets/finish_icon.svg';
import AuraLogo from '../../assets/aura.svg';
import AutouLogo from '../../assets/autou.svg';
import Return from '../../assets/return_icon_button.svg';

const Final = () => {
  const { state, dispatch } = useGlobal();
  const navigate = useNavigate();
  const [currentDateTime, setCurrentDateTime] = useState('');

  // Efeito que roda apenas uma vez para gerar a data e hora
  useEffect(() => {
    const date = new Date();
    // Formatando para "DD Mês YYYY - HH:MM"
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).replace(/ de/g, '').replace(/\./g, '');
    
    const formattedTime = date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    setCurrentDateTime(`${formattedDate} - ${formattedTime}`);
  }, []); // O array vazio [] garante que rode apenas uma vez

  const handleRestart = () => {
    dispatch({ type: 'RESET_STATE' });
    navigate('/');
  };

  return (
    <motion.div
                  className="final-container"
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -24 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                >
      <Confetti recycle={false} numberOfPieces={500} />
      <img src={FinishIcon} alt="Ícone de finalizado" className="finish-icon" />
      <h1 className="final-title">Masterplan enviado!</h1>
      <p className="final-subtitle">
        Você está a uma reunião de mudar seu processo com IA!
      </p>

      {/* O container do recibo usará o SVG como fundo */}
      <div className="ticket-container">
        <div className="ticket-content">


          <div className="ticket-details">
            
          </div>
        </div>
      </div>

      <button className="restart-button" onClick={handleRestart}>
        <img src={Return} alt="Return button" className="return-icon" />
      </button>
    </motion.div>
  );
};

export default Final;